import { TFunction } from "react-i18next";



export enum MEDIA_TYPE {
    BOOK = "books",              // หนังสือ
    E_BOOK = "e_books",          // E-Book
    MAGAZINE = "magazine",      // วารสาร
    THESIS = "thesis",          // วิทยานิพนธ์
    PODCAST = "podcast",        // พอดแคสต์
    AUDIO_BOOK = "audio_books",    // หนังสือเสียง
    VIDEO = "video",            // วิดีโอ
}
// ป้ายชื่อด้านล่างเป็นภาษาไทยที่ใช้เป็น key ของ i18n: แปลตอน render ด้วย t(x.name) / t(x.label) ห้ามเรียก t() ที่ module scope
export const index_media_type: string[] = ['หนังสือ', 'E-Book', 'วารสาร', 'วิทยานิพนธ์', 'พอดแคสต์', 'หนังสือเสียง', 'วิดีโอ'] // i18n-ignore


export const media_type_data = Object.entries(MEDIA_TYPE).map(([key, value], i) => {
    return {
        key,
        name: index_media_type[i],
        value
    }
})


export type document_category_type = {
    id_library_category: number;
    id_library_document_category: number;
    id_library_file_document: number;
    library_file_document: string;
    seq: number;
    link_file: string;
    checked_example?: boolean;
}


// list
export enum ELibraryCategory {
    BOOK = 'BOOK',
    E_BOOK = 'E_BOOK',
    MAGAZINE = "MAGAZINE",
    THESIS = 'THESIS',
    PODCAST = 'PODCAST',
    AUDIO_BOOK = 'AUDIO_BOOK',
    VIDEO = 'VIDEO',
}

export const media_type_data_category = Object.entries(ELibraryCategory).map(([key, value], i) => {
    return {
        key,
        name: index_media_type[i],
        value
    }
})


export const header_detail = (t: TFunction<"translation", undefined>): {
    key: string;
    header_name: string;
    header_position: string;
    specify_header_name?: string;
    specify_header_position?: string;

}[] => {

    return [
        {
            key: ELibraryCategory.BOOK,
            header_name: t("ชื่อหนังสือ"),
            specify_header_name: t("ระบุชื่อหนังสือ"),
            header_position: t("สำนักพิมพ์"),
            specify_header_position: t("ระบุสำนักพิมพ์")
        },
        {
            key: ELibraryCategory.E_BOOK,
            header_name: t("ชื่อหนังสือ"),
            specify_header_name: t("ระบุชื่อหนังสือ"),
            header_position: t("สำนักพิมพ์"),
            specify_header_position: t("ระบุสำนักพิมพ์")
        },
        {
            key: ELibraryCategory.THESIS,
            header_name: t("ชื่อวิทยานิพนธ์"),
            specify_header_name: t("ระบุชื่อวิทยานิพนธ์"),
            header_position: t("สังกัด"),
            specify_header_position: t("ระบุสังกัด")
        },
        {
            key: ELibraryCategory.MAGAZINE,
            header_name: t("ชื่อวารสาร"),
            specify_header_name: t("ระบุชื่อวารสาร"),
            header_position: t("สังกัด"),
            specify_header_position: t("ระบุสังกัด")
        },
        {
            key: ELibraryCategory.PODCAST,
            header_name: t("ชื่อพอดแคสต์"),
            specify_header_name: t("ระบุชื่อพอดแคสต์"),
            header_position: t("สำนักพิมพ์"),
            specify_header_position: t("ระบุสำนักพิมพ์")
        },
        {
            key: ELibraryCategory.VIDEO,
            header_name: t("ชื่อวีดีโอ"),
            specify_header_name: t("ระบุชื่อวีดีโอ"),
            header_position: t("สำนักพิมพ์"),
            specify_header_position: t("ระบุสำนักพิมพ์")
        },
        {
            key: ELibraryCategory.AUDIO_BOOK,
            header_name: t("ชื่อหนังสือเสียง"),
            specify_header_name: t("ระบุชื่อหนังสือเสียง"),
            header_position: t("สำนักพิมพ์"),
            specify_header_position: t("ระบุสำนักพิมพ์")
        },
    ]
}
export enum LIBRARY_HEAD_STATUS {
    NEW = 'NEW',//มาใหม่
    POPULAR = 'POPULAR',//มาแรง
    GENERAL = 'GENERAL',//ทั่วไป
    ALL = "ALL"
}
export enum LANGUAGE_LIBRARY {
    TH = 'TH',
    EN = 'EN',
}
export const language_library_data = Object.entries(LANGUAGE_LIBRARY).map(([_, val], index) => {
    return {
        label: val,
        value: val
    }
})
// name แปลตอน render ด้วย t(x.name)
const head_status_name: string[] = ['มาใหม่', 'มาแรง', 'ทั่วไป'] // i18n-ignore
export const head_status_data = Object.entries(LIBRARY_HEAD_STATUS).map(([_, val], index) => {
    return {
        name: head_status_name[index],
        value: val
    }
})

export enum LIBRARY_DETAIL_TYPE {
    SALES = 'SALES',
    RENT = 'RENT'
}
export enum CATEGORY_LIBRARY {
    BOOKS = 'books',
    E_BOOKS = 'e_books',
    MAGAZINE = 'magazine',
    THESIS = 'thesis',
    PODCAST = 'podcast',
    AUDIO_BOOK = 'audio_books',
    VIDEO = 'video',
}
// ค่า enum ด้านล่างเป็นค่าที่บันทึก/เทียบกับ backend (library_file_document) ห้ามแปลค่า ให้แปลตอนแสดงผลด้วย t(value)
export enum FILE_TYPE_DATA {
    COVER_FILE = "ไฟล์ภาพปก", // i18n-ignore
    EXAMPLE_BOOK = "ไฟล์ตัวอย่างหนังสือ", // i18n-ignore
    COMPLETE_BOOK = "ไฟล์หนังสือฉบับสมบูรณ์", // i18n-ignore
    COMPLETE_THE_SIS_FILE = "ไฟล์วิทยานิพนธ์ฉบับสมบูรณ์", // i18n-ignore
    JOURNAL_FILE = "ไฟล์วารสาร", // i18n-ignore
    POD_CAST = "ไฟล์พอดแคสต์", // i18n-ignore
    AUDIO_BOOK = "ไฟล์หนังสือเสียง", // i18n-ignore
    VIDEO_FILE = "ไฟล์วีดีโอ" // i18n-ignore
}

export enum E_LIBRARY_CATEGORY {
    BOOK = 'BOOK',
    E_BOOK = 'E_BOOK',
    MAGAZINE = 'MAGAZINE',
    THESIS = 'THESIS',
    PODCAST = 'PODCAST',
    AUDIO_BOOK = 'AUDIO_BOOK',
    VIDEO = 'VIDEO',
}

export enum LIBRARY_FILE_TYPE {
    VIDEO = 'VIDEO',
    VOICE = 'VOICE',
    FILE = 'FILE',
    LINK = 'LINK'

}



export enum STATUS_E_LIBRARY {
    DRAFT = "inactive",
    PUBLISH = "active",
    DELETED = "delete"
}


export enum LIBRARY_DETAIL_STATUS {
    STOCK = 'STOCK', // มีของ
    PENDING_PAYMENT = 'PENDING_PAYMENT', // รอจ่ายเงิน
    SOLD = 'SOLD', // ขายแล้ว
    BORROW = 'BORROW', // ถูกยืม
}



// ค่าสถานะด้านล่างเป็นค่าที่บันทึก/เทียบกับ backend ห้ามแปลค่า ให้แปลตอนแสดงผลด้วย t(value)
export enum LIBRARY_HISTORY_STATUS {
    // ฝั่งยืม
    WAITING_APPROVE_BORROW = 'รอยืนยันการยืม', // i18n-ignore
    BORROW = 'กำลังยืม', // i18n-ignore
    WAITING_APPROVE_RETURN = 'รอยืนยันการคืน', // i18n-ignore
    APPROVE_RETURN = 'คืนแล้ว', // i18n-ignore
}

export const library_history_status_data = Object.entries(LIBRARY_HISTORY_STATUS).map(([key, values]) => {
    return {
        label: values,
        value: values,
        key: key,
    }
})

export enum LIBRARY_LIKE {
    LIKE = 'LIKE',
    BOOKMARK = 'BOOKMARK',
}


// ค่าสถานะด้านล่างเป็นค่าที่บันทึก/เทียบกับ backend ห้ามแปลค่า ให้แปลตอนแสดงผลด้วย t(value)
export enum LIBRARY_PAYMENT_STATUS {
    WAITING_APPROVE_PAYMENT = 'รอยืนยันการชำระเงิน', // i18n-ignore
    APPROVE_PAYMENT = 'ยืนยันการชำระเงินแล้ว', // i18n-ignore
    REJECT_PAYMENT = 'ชำระไม่ผ่าน', // i18n-ignore
    RECEIVED_BOOK = 'รับหนังสือแล้ว', // i18n-ignore
}

export const library_payment_status_data: { label: string, value: string }[] = Object.entries(LIBRARY_PAYMENT_STATUS).map(([key, value]) => {
    return {
        label: value,
        value: value
    }
})

export enum LIBRARY_DETAIL_HISTORY_TYPE {
    BORROW = 'BORROW', // ยืม
    BOOKED = 'BOOKED', // จอง
    DOWNLOAD = 'DOWNLOAD',
    PENDING_PAYMENT = 'PENDING_PAYMENT', //จองเพื่อชำระ
    WAITING_CONFIRM_PAYMENT = 'WAITING_CONFIRM_PAYMENT', //รอยืนยันชำระ
    SOLD = 'SOLD', // ขาย
    CART = 'CART', // ตะกร้า
}


// label เป็นข้อความไทยที่ใช้เป็น key ของ i18n: แปลตอน render ด้วย t(x.label)
export const libraryDetailHistoryOptions = [
    { label: "ยืม", value: LIBRARY_DETAIL_HISTORY_TYPE.BORROW }, // i18n-ignore
    { label: "จอง", value: LIBRARY_DETAIL_HISTORY_TYPE.BOOKED }, // i18n-ignore
    { label: "ดาวน์โหลด", value: LIBRARY_DETAIL_HISTORY_TYPE.DOWNLOAD }, // i18n-ignore
    { label: "จองเพื่อชำระ", value: LIBRARY_DETAIL_HISTORY_TYPE.PENDING_PAYMENT }, // i18n-ignore
    { label: "รอยืนยันชำระ", value: LIBRARY_DETAIL_HISTORY_TYPE.WAITING_CONFIRM_PAYMENT }, // i18n-ignore
    { label: "ขาย", value: LIBRARY_DETAIL_HISTORY_TYPE.SOLD }, // i18n-ignore
    { label: "ตะกร้า", value: LIBRARY_DETAIL_HISTORY_TYPE.CART }, // i18n-ignore
];

// ค่า enum ด้านล่างเป็นค่าที่บันทึก/เทียบกับ backend ห้ามแปลค่า ให้แปลตอนแสดงผลด้วย t(value)
export enum FILE_DOCUMENT_CATEGORY {
    COVER_IMAGE = 'ไฟล์ภาพปก', // i18n-ignore
    SAMPLE_BOOK = 'ไฟล์ตัวอย่างหนังสือ', // i18n-ignore
    FULL_BOOK = 'ไฟล์หนังสือฉบับสมบูรณ์', // i18n-ignore
    FULL_THESIS = 'ไฟล์วิทยานิพนธ์ฉบับสมบูรณ์', // i18n-ignore
    PODCAST = 'ไฟล์พอดแคสต์', // i18n-ignore
    AUDIO_BOOK = 'ไฟล์หนังสือเสียง', // i18n-ignore
    VIDEO = 'ไฟล์วีดีโอ', // i18n-ignore
    JOURNAL = 'ไฟล์วารสาร', // i18n-ignore
}



export enum Period {
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH",
    YEAR = "YEAR",
}

// label เป็นข้อความไทยที่ใช้เป็น key ของ i18n: แปลตอน render ด้วย t(x.label)
export const periodOptions = [
    { label: "รายวัน", value: Period.DAY }, // i18n-ignore
    { label: "รายสัปดาห์", value: Period.WEEK }, // i18n-ignore
    { label: "รายเดือน", value: Period.MONTH }, // i18n-ignore
    { label: "รายปี", value: Period.YEAR }, // i18n-ignore
];



export enum PERSON_TYPE {
    STAFF = "1",          // บุคลากร
    EXTERNAL = "2",    // บุคคลภายนอก
}

// label เป็นข้อความไทยที่ใช้เป็น key ของ i18n: แปลตอน render ด้วย t(x.label)
export const PERSON_TYPE_OPTIONS = [
    { value: PERSON_TYPE.STAFF, label: "บุคลากร" }, // i18n-ignore
    { value: PERSON_TYPE.EXTERNAL, label: "บุคคลภายนอก" }, // i18n-ignore
];